import React from 'react';

import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { FavoriteButton } from './favorite_button';
import { ExternalProps, useFindFavorite } from './find_favorite_context';
import { LoggedOutFavoriteButton } from './logged_out_favorite_button';

export function FavoriteButtonContainer(props: ExternalProps) {
  const {
    canFavorite,
  } = useFindFavorite();
  const user = useUser();

  if (!canFavorite) return null;

  const isMutedButton = props.displayStyle === 'muted-button';
  const buttonTypeOverride = isMutedButton ? 'muted' as const
    : props.displayStyle === 'link' ? 'link' as const
      : undefined;

  return (
    <div className="favorite-button">
      {
        user.loggedOut ?
          <LoggedOutFavoriteButton
            renderWithBanner={false}
            buttonTypeOverride={buttonTypeOverride}
            condensed={props.condensed}
            iconButtonSize={props.iconButtonSize}
            iconButtonVariant={props.iconButtonVariant}
          />
          :
          <FavoriteButton
            renderWithBanner={false}
            buttonTypeOverride={buttonTypeOverride}
            componentName={props.componentName}
            condensed={props.condensed}
            iconButtonSize={props.iconButtonSize}
            iconButtonVariant={props.iconButtonVariant}
          />
      }
    </div>
  );
}
